module.exports = __webpack_public_path__ + "img/chat.d5c99bde.png";